import { render, staticRenderFns } from "./addSalesChannel.vue?vue&type=template&id=bc25870e&scoped=true&"
import script from "./addSalesChannel.vue?vue&type=script&lang=ts&"
export * from "./addSalesChannel.vue?vue&type=script&lang=ts&"
import style0 from "./addSalesChannel.vue?vue&type=style&index=0&id=bc25870e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc25870e",
  null
  
)

export default component.exports